/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function DefaultFooter() {
  return (
    <>
      <footer className="footer footer-default">
        <Container>
          <nav>
            <ul>
              <li>
                <a
                  href="#"
                  target="_blank"
                >
                  Solarlink
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  target="_blank"
                >
                  Kontakt
                </a>
              </li>
              <li>
                <a
                  href="/faq"
                  target="_blank"
                >
                  FAQs
                </a>
              </li>
            </ul>
          </nav>
          <div className="copyright" id="copyright">
            © {new Date().getFullYear()}, 
            Coded by{" "}
            <a
              href="https://www.webnetglobal.com/"
              target="_blank"
            >
              WebNet Global
            </a>
          </div>
        </Container>
      </footer>
    </>
  );
}

export default DefaultFooter;
